import React from 'react';
import S from './Input.styles';
const Input = React.forwardRef((props, ref) => {
    return React.createElement(S.Input, { ref: ref, ...props });
});
Input.displayName = 'Input';
export default Input;
